import { Link } from "react-router-dom";
import { CheckCircle2, Landmark, Mail, ArrowRight } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function RegisterBonificoSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-emerald-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full shadow-xl border-0">
        <CardContent className="p-8 text-center">
          {/* Icona principale */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-emerald-100 flex items-center justify-center">
            <CheckCircle2 className="w-10 h-10 text-emerald-600" />
          </div>

          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Registrazione completata!
          </h1>
          <p className="text-slate-600 mb-6">
            La tua registrazione su <strong>Affidya</strong> è andata a buon fine.
          </p>

          {/* Istruzioni bonifico */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-6 text-left">
            <div className="flex items-center gap-2 mb-3">
              <Landmark className="w-5 h-5 text-amber-700 shrink-0" />
              <p className="font-semibold text-amber-800">Prossimi passi per attivare l'account</p>
            </div>
            <ol className="space-y-2 text-sm text-amber-900 list-none">
              <li className="flex gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-amber-200 text-amber-800 font-bold text-xs shrink-0 mt-0.5">1</span>
                <span>Controlla la tua casella email: ti abbiamo inviato le <strong>coordinate bancarie</strong> e il riepilogo del piano scelto.</span>
              </li>
              <li className="flex gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-amber-200 text-amber-800 font-bold text-xs shrink-0 mt-0.5">2</span>
                <span>Effettua il <strong>bonifico bancario</strong> usando i dati e la causale indicati nell'email.</span>
              </li>
              <li className="flex gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-amber-200 text-amber-800 font-bold text-xs shrink-0 mt-0.5">3</span>
                <span>Appena verificheremo l'accredito (di solito entro <strong>1–2 giorni lavorativi</strong>) attiveremo il tuo account e riceverai una conferma via email.</span>
              </li>
            </ol>
          </div>

          {/* Nota email */}
          <div className="flex items-center justify-center gap-2 text-sm text-slate-500 mb-8">
            <Mail className="w-4 h-4" />
            <span>Non hai ricevuto l'email? Controlla la cartella spam o contatta il supporto.</span>
          </div>

          {/* CTA */}
          <Button asChild className="w-full h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-base font-semibold">
            <Link to="/login">
              Torna al login <ArrowRight className="w-5 h-5 ml-2" />
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
